import { change } from 'redux-form';

import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME } from 'Common/FormEnum';
import * as types from './types';

export const getKitchenList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_KITCHEN_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('sitemaster');
      dispatch(success(types.KITCHEN_LIST_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Kitchen list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_KITCHEN_LIST_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_KITCHEN_LIST_LOADING, false));
    }
  };
};

export const getAvailableKitchenPrepWorksheetItems = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.AVAILABLE_KITCHEN_PREP_WORKSHEET_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/GetAvailableKitchenPreparedItems',
        requestObj
      );
      dispatch(
        success(types.AVAILABLE_KITCHEN_PREP_WORKSHEET_DATA, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching available kitchen prep worksheet list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.AVAILABLE_KITCHEN_PREP_WORKSHEET_FETCHING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.AVAILABLE_KITCHEN_PREP_WORKSHEET_LOADING, false));
    }
  };
};

export const emptyAvailableTableData = () => {
  return {
    type: types.AVAILABLE_KITCHEN_PREP_WORKSHEET_DATA,
    payload: [],
  };
};

export const clearAvailableKitchenPrepError = () => {
  return {
    type: types.CLEAR_AVAILABLE_KITCHEN_ERROR,
  };
};
export const changeDropDownData = (dropDownName, data) => {
  return change(
    CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME,
    dropDownName,
    data
  );
};

export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};

export const resetDateRange = () => {
  return {
    type: types.RESET_DATE_RANGE,
  };
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/availableKitchenPrepWorksheet/actions.js